/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ConnectLoginRouteImport } from './routes/connect/login'
import { Route as ConnectAuthenticatedRouteImport } from './routes/connect/_authenticated'
import { Route as ConnectAuthenticatedQuoteStatusRouteImport } from './routes/connect/_authenticated/quoteStatus'
import { Route as ConnectAuthenticatedQuoteRequestsRouteImport } from './routes/connect/_authenticated/quoteRequests'
import { Route as ConnectAuthenticatedPackageVendorPicksRouteImport } from './routes/connect/_authenticated/packageVendorPicks'
import { Route as ConnectAuthenticatedPackageProgressRouteImport } from './routes/connect/_authenticated/packageProgress'
import { Route as ConnectAuthenticatedConfirmationRouteImport } from './routes/connect/_authenticated/confirmation'
import { Route as ConnectAuthenticatedElectrify2515IndexRouteImport } from './routes/connect/_authenticated/electrify2515/index'
import { Route as ConnectAuthenticatedDefaultIndexRouteImport } from './routes/connect/_authenticated/default/index'
import { Route as ConnectAuthenticatedCbaIndexRouteImport } from './routes/connect/_authenticated/cba/index'
import { Route as ConnectAuthenticatedElectrify2515PaymentRouteImport } from './routes/connect/_authenticated/electrify2515/payment'
import { Route as ConnectAuthenticatedElectrify2515CategoryRouteImport } from './routes/connect/_authenticated/electrify2515/$category'
import { Route as ConnectAuthenticatedDefaultPaymentRouteImport } from './routes/connect/_authenticated/default/payment'
import { Route as ConnectAuthenticatedCbaPaymentRouteImport } from './routes/connect/_authenticated/cba/payment'

const ConnectLoginRoute = ConnectLoginRouteImport.update({
  id: '/connect/login',
  path: '/connect/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectAuthenticatedRoute = ConnectAuthenticatedRouteImport.update({
  id: '/connect/_authenticated',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectAuthenticatedQuoteStatusRoute =
  ConnectAuthenticatedQuoteStatusRouteImport.update({
    id: '/quoteStatus',
    path: '/quoteStatus',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedQuoteRequestsRoute =
  ConnectAuthenticatedQuoteRequestsRouteImport.update({
    id: '/quoteRequests',
    path: '/quoteRequests',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedPackageVendorPicksRoute =
  ConnectAuthenticatedPackageVendorPicksRouteImport.update({
    id: '/packageVendorPicks',
    path: '/packageVendorPicks',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedPackageProgressRoute =
  ConnectAuthenticatedPackageProgressRouteImport.update({
    id: '/packageProgress',
    path: '/packageProgress',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedConfirmationRoute =
  ConnectAuthenticatedConfirmationRouteImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedElectrify2515IndexRoute =
  ConnectAuthenticatedElectrify2515IndexRouteImport.update({
    id: '/electrify2515/',
    path: '/electrify2515/',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedDefaultIndexRoute =
  ConnectAuthenticatedDefaultIndexRouteImport.update({
    id: '/default/',
    path: '/default/',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedCbaIndexRoute =
  ConnectAuthenticatedCbaIndexRouteImport.update({
    id: '/cba/',
    path: '/cba/',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedElectrify2515PaymentRoute =
  ConnectAuthenticatedElectrify2515PaymentRouteImport.update({
    id: '/electrify2515/payment',
    path: '/electrify2515/payment',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedElectrify2515CategoryRoute =
  ConnectAuthenticatedElectrify2515CategoryRouteImport.update({
    id: '/electrify2515/$category',
    path: '/electrify2515/$category',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedDefaultPaymentRoute =
  ConnectAuthenticatedDefaultPaymentRouteImport.update({
    id: '/default/payment',
    path: '/default/payment',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)
const ConnectAuthenticatedCbaPaymentRoute =
  ConnectAuthenticatedCbaPaymentRouteImport.update({
    id: '/cba/payment',
    path: '/cba/payment',
    getParentRoute: () => ConnectAuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/connect': typeof ConnectAuthenticatedRouteWithChildren
  '/connect/login': typeof ConnectLoginRoute
  '/connect/confirmation': typeof ConnectAuthenticatedConfirmationRoute
  '/connect/packageProgress': typeof ConnectAuthenticatedPackageProgressRoute
  '/connect/packageVendorPicks': typeof ConnectAuthenticatedPackageVendorPicksRoute
  '/connect/quoteRequests': typeof ConnectAuthenticatedQuoteRequestsRoute
  '/connect/quoteStatus': typeof ConnectAuthenticatedQuoteStatusRoute
  '/connect/cba/payment': typeof ConnectAuthenticatedCbaPaymentRoute
  '/connect/default/payment': typeof ConnectAuthenticatedDefaultPaymentRoute
  '/connect/electrify2515/$category': typeof ConnectAuthenticatedElectrify2515CategoryRoute
  '/connect/electrify2515/payment': typeof ConnectAuthenticatedElectrify2515PaymentRoute
  '/connect/cba/': typeof ConnectAuthenticatedCbaIndexRoute
  '/connect/default/': typeof ConnectAuthenticatedDefaultIndexRoute
  '/connect/electrify2515/': typeof ConnectAuthenticatedElectrify2515IndexRoute
}
export interface FileRoutesByTo {
  '/connect': typeof ConnectAuthenticatedRouteWithChildren
  '/connect/login': typeof ConnectLoginRoute
  '/connect/confirmation': typeof ConnectAuthenticatedConfirmationRoute
  '/connect/packageProgress': typeof ConnectAuthenticatedPackageProgressRoute
  '/connect/packageVendorPicks': typeof ConnectAuthenticatedPackageVendorPicksRoute
  '/connect/quoteRequests': typeof ConnectAuthenticatedQuoteRequestsRoute
  '/connect/quoteStatus': typeof ConnectAuthenticatedQuoteStatusRoute
  '/connect/cba/payment': typeof ConnectAuthenticatedCbaPaymentRoute
  '/connect/default/payment': typeof ConnectAuthenticatedDefaultPaymentRoute
  '/connect/electrify2515/$category': typeof ConnectAuthenticatedElectrify2515CategoryRoute
  '/connect/electrify2515/payment': typeof ConnectAuthenticatedElectrify2515PaymentRoute
  '/connect/cba': typeof ConnectAuthenticatedCbaIndexRoute
  '/connect/default': typeof ConnectAuthenticatedDefaultIndexRoute
  '/connect/electrify2515': typeof ConnectAuthenticatedElectrify2515IndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/connect/_authenticated': typeof ConnectAuthenticatedRouteWithChildren
  '/connect/login': typeof ConnectLoginRoute
  '/connect/_authenticated/confirmation': typeof ConnectAuthenticatedConfirmationRoute
  '/connect/_authenticated/packageProgress': typeof ConnectAuthenticatedPackageProgressRoute
  '/connect/_authenticated/packageVendorPicks': typeof ConnectAuthenticatedPackageVendorPicksRoute
  '/connect/_authenticated/quoteRequests': typeof ConnectAuthenticatedQuoteRequestsRoute
  '/connect/_authenticated/quoteStatus': typeof ConnectAuthenticatedQuoteStatusRoute
  '/connect/_authenticated/cba/payment': typeof ConnectAuthenticatedCbaPaymentRoute
  '/connect/_authenticated/default/payment': typeof ConnectAuthenticatedDefaultPaymentRoute
  '/connect/_authenticated/electrify2515/$category': typeof ConnectAuthenticatedElectrify2515CategoryRoute
  '/connect/_authenticated/electrify2515/payment': typeof ConnectAuthenticatedElectrify2515PaymentRoute
  '/connect/_authenticated/cba/': typeof ConnectAuthenticatedCbaIndexRoute
  '/connect/_authenticated/default/': typeof ConnectAuthenticatedDefaultIndexRoute
  '/connect/_authenticated/electrify2515/': typeof ConnectAuthenticatedElectrify2515IndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/connect'
    | '/connect/login'
    | '/connect/confirmation'
    | '/connect/packageProgress'
    | '/connect/packageVendorPicks'
    | '/connect/quoteRequests'
    | '/connect/quoteStatus'
    | '/connect/cba/payment'
    | '/connect/default/payment'
    | '/connect/electrify2515/$category'
    | '/connect/electrify2515/payment'
    | '/connect/cba/'
    | '/connect/default/'
    | '/connect/electrify2515/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connect'
    | '/connect/login'
    | '/connect/confirmation'
    | '/connect/packageProgress'
    | '/connect/packageVendorPicks'
    | '/connect/quoteRequests'
    | '/connect/quoteStatus'
    | '/connect/cba/payment'
    | '/connect/default/payment'
    | '/connect/electrify2515/$category'
    | '/connect/electrify2515/payment'
    | '/connect/cba'
    | '/connect/default'
    | '/connect/electrify2515'
  id:
    | '__root__'
    | '/connect/_authenticated'
    | '/connect/login'
    | '/connect/_authenticated/confirmation'
    | '/connect/_authenticated/packageProgress'
    | '/connect/_authenticated/packageVendorPicks'
    | '/connect/_authenticated/quoteRequests'
    | '/connect/_authenticated/quoteStatus'
    | '/connect/_authenticated/cba/payment'
    | '/connect/_authenticated/default/payment'
    | '/connect/_authenticated/electrify2515/$category'
    | '/connect/_authenticated/electrify2515/payment'
    | '/connect/_authenticated/cba/'
    | '/connect/_authenticated/default/'
    | '/connect/_authenticated/electrify2515/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ConnectAuthenticatedRoute: typeof ConnectAuthenticatedRouteWithChildren
  ConnectLoginRoute: typeof ConnectLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/connect/login': {
      id: '/connect/login'
      path: '/connect/login'
      fullPath: '/connect/login'
      preLoaderRoute: typeof ConnectLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/_authenticated': {
      id: '/connect/_authenticated'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectAuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/_authenticated/quoteStatus': {
      id: '/connect/_authenticated/quoteStatus'
      path: '/quoteStatus'
      fullPath: '/connect/quoteStatus'
      preLoaderRoute: typeof ConnectAuthenticatedQuoteStatusRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/quoteRequests': {
      id: '/connect/_authenticated/quoteRequests'
      path: '/quoteRequests'
      fullPath: '/connect/quoteRequests'
      preLoaderRoute: typeof ConnectAuthenticatedQuoteRequestsRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/packageVendorPicks': {
      id: '/connect/_authenticated/packageVendorPicks'
      path: '/packageVendorPicks'
      fullPath: '/connect/packageVendorPicks'
      preLoaderRoute: typeof ConnectAuthenticatedPackageVendorPicksRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/packageProgress': {
      id: '/connect/_authenticated/packageProgress'
      path: '/packageProgress'
      fullPath: '/connect/packageProgress'
      preLoaderRoute: typeof ConnectAuthenticatedPackageProgressRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/confirmation': {
      id: '/connect/_authenticated/confirmation'
      path: '/confirmation'
      fullPath: '/connect/confirmation'
      preLoaderRoute: typeof ConnectAuthenticatedConfirmationRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/electrify2515/': {
      id: '/connect/_authenticated/electrify2515/'
      path: '/electrify2515'
      fullPath: '/connect/electrify2515/'
      preLoaderRoute: typeof ConnectAuthenticatedElectrify2515IndexRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/default/': {
      id: '/connect/_authenticated/default/'
      path: '/default'
      fullPath: '/connect/default/'
      preLoaderRoute: typeof ConnectAuthenticatedDefaultIndexRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/cba/': {
      id: '/connect/_authenticated/cba/'
      path: '/cba'
      fullPath: '/connect/cba/'
      preLoaderRoute: typeof ConnectAuthenticatedCbaIndexRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/electrify2515/payment': {
      id: '/connect/_authenticated/electrify2515/payment'
      path: '/electrify2515/payment'
      fullPath: '/connect/electrify2515/payment'
      preLoaderRoute: typeof ConnectAuthenticatedElectrify2515PaymentRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/electrify2515/$category': {
      id: '/connect/_authenticated/electrify2515/$category'
      path: '/electrify2515/$category'
      fullPath: '/connect/electrify2515/$category'
      preLoaderRoute: typeof ConnectAuthenticatedElectrify2515CategoryRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/default/payment': {
      id: '/connect/_authenticated/default/payment'
      path: '/default/payment'
      fullPath: '/connect/default/payment'
      preLoaderRoute: typeof ConnectAuthenticatedDefaultPaymentRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
    '/connect/_authenticated/cba/payment': {
      id: '/connect/_authenticated/cba/payment'
      path: '/cba/payment'
      fullPath: '/connect/cba/payment'
      preLoaderRoute: typeof ConnectAuthenticatedCbaPaymentRouteImport
      parentRoute: typeof ConnectAuthenticatedRoute
    }
  }
}

interface ConnectAuthenticatedRouteChildren {
  ConnectAuthenticatedConfirmationRoute: typeof ConnectAuthenticatedConfirmationRoute
  ConnectAuthenticatedPackageProgressRoute: typeof ConnectAuthenticatedPackageProgressRoute
  ConnectAuthenticatedPackageVendorPicksRoute: typeof ConnectAuthenticatedPackageVendorPicksRoute
  ConnectAuthenticatedQuoteRequestsRoute: typeof ConnectAuthenticatedQuoteRequestsRoute
  ConnectAuthenticatedQuoteStatusRoute: typeof ConnectAuthenticatedQuoteStatusRoute
  ConnectAuthenticatedCbaPaymentRoute: typeof ConnectAuthenticatedCbaPaymentRoute
  ConnectAuthenticatedDefaultPaymentRoute: typeof ConnectAuthenticatedDefaultPaymentRoute
  ConnectAuthenticatedElectrify2515CategoryRoute: typeof ConnectAuthenticatedElectrify2515CategoryRoute
  ConnectAuthenticatedElectrify2515PaymentRoute: typeof ConnectAuthenticatedElectrify2515PaymentRoute
  ConnectAuthenticatedCbaIndexRoute: typeof ConnectAuthenticatedCbaIndexRoute
  ConnectAuthenticatedDefaultIndexRoute: typeof ConnectAuthenticatedDefaultIndexRoute
  ConnectAuthenticatedElectrify2515IndexRoute: typeof ConnectAuthenticatedElectrify2515IndexRoute
}

const ConnectAuthenticatedRouteChildren: ConnectAuthenticatedRouteChildren = {
  ConnectAuthenticatedConfirmationRoute: ConnectAuthenticatedConfirmationRoute,
  ConnectAuthenticatedPackageProgressRoute:
    ConnectAuthenticatedPackageProgressRoute,
  ConnectAuthenticatedPackageVendorPicksRoute:
    ConnectAuthenticatedPackageVendorPicksRoute,
  ConnectAuthenticatedQuoteRequestsRoute:
    ConnectAuthenticatedQuoteRequestsRoute,
  ConnectAuthenticatedQuoteStatusRoute: ConnectAuthenticatedQuoteStatusRoute,
  ConnectAuthenticatedCbaPaymentRoute: ConnectAuthenticatedCbaPaymentRoute,
  ConnectAuthenticatedDefaultPaymentRoute:
    ConnectAuthenticatedDefaultPaymentRoute,
  ConnectAuthenticatedElectrify2515CategoryRoute:
    ConnectAuthenticatedElectrify2515CategoryRoute,
  ConnectAuthenticatedElectrify2515PaymentRoute:
    ConnectAuthenticatedElectrify2515PaymentRoute,
  ConnectAuthenticatedCbaIndexRoute: ConnectAuthenticatedCbaIndexRoute,
  ConnectAuthenticatedDefaultIndexRoute: ConnectAuthenticatedDefaultIndexRoute,
  ConnectAuthenticatedElectrify2515IndexRoute:
    ConnectAuthenticatedElectrify2515IndexRoute,
}

const ConnectAuthenticatedRouteWithChildren =
  ConnectAuthenticatedRoute._addFileChildren(ConnectAuthenticatedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ConnectAuthenticatedRoute: ConnectAuthenticatedRouteWithChildren,
  ConnectLoginRoute: ConnectLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
